import React from "react";
import Glutin from "../../static/Glutin.svg";
import Laitier from "../../static/Laitier.svg";
import Ail from "../../static/Ail.svg";
import Arachides from "../../static/Arachides.svg";
import Céleri from "../../static/Céleri.svg";
import Champignons from "../../static/Champignons.svg";
import Crustacés from "../../static/Crustacés.svg";
import Fruits from "../../static/Fruits.svg";
import Lupin from "../../static/Lupin.svg";
import Mollusques from "../../static/Mollusques.svg";
import Moutarde from "../../static/Moutarde.svg";
import Oeuf from "../../static/Oeuf.svg";
import Poisson from "../../static/Poisson.svg";
import Sésames from "../../static/Sésames.svg";
import Soga from "../../static/Soga.svg";
import Sulfites from "../../static/Sulfites.svg";
import Tomates from "../../static/Tomates.svg";
import Sign from "../../static/sign.svg";
import Halal from "../../static/Halal.svg";
import Kosher from "../../static/Kosher.svg";
import Paleo from "../../static/Paleo.svg";
import Pescatarien from "../../static/Pescatarien.svg";
import Sans_porc from "../../static/Sans_porc.svg";
import Sans_sucre from "../../static/Sans_sucre.svg";
import Enceinte from "../../static/Enceinte.svg";
import Seafood from "../../static/Seafood.svg";
import Vegan from "../../static/Vegan.svg";
import Végétarien from "../../static/Végétarien.svg";
import Diabétique from "../../static/Diabétique.svg";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Stack,
  Input,
} from "@mui/material";
import axios from "axios";

interface ModifProps {
  onCancel: () => void;
  employeeData: any;
  id: Number;
}
const apiUrl =
  window.location.hostname === "localhost"
    ? "https://localhost:7142/api"
    : "/api";
function App({ employeeData, onCancel, id }: ModifProps) {
  const [formData, setFormData] = React.useState({
    ContractType: employeeData.contractType || null,
    ContractStartDate: employeeData.contractStartDate || null,
    ContractEndDate: employeeData.contractEndDate || null,
    Service: employeeData.service,
    Responsabilite: employeeData.responsabilite,
    Nom: employeeData.nom,
    Prenom: employeeData.prenom,
    Poste: employeeData.poste,
    Email: employeeData.email,
    Gluten: employeeData.gluten || false,
    Oeuf: employeeData.oeuf || false,
    Soja: employeeData.soja || false,
    Moutarde: employeeData.moutarde || false,
    Mollusques: employeeData.mollusques || false,
    Champignons: employeeData.champignons || false,
    Laitier: employeeData.laitier || false,
    Poisson: employeeData.poisson || false,
    Coques: employeeData.coques || false,
    Sesames: employeeData.sesames || false,
    Ail: employeeData.ail || false,
    Tomates: employeeData.tomates || false,
    Crustaces: employeeData.crustaces || false,
    Arachides: employeeData.arachides || false,
    Celeri: employeeData.celeri || false,
    Sulfites: employeeData.sulfites || false,
    Lupin: employeeData.lupin || false,
    Halal: employeeData.halal || false,
    Pescatarien: employeeData.pescatarien || false,
    Enceinte: employeeData.enceinte || false,
    Vegetarien: employeeData.vegetarien || false,
    Kosher: employeeData.kosher || false,
    Porc: employeeData.porc || false,
    Seafood: employeeData.seafood || false,
    Diabetique: employeeData.diabetique || false,
    Paleo: employeeData.paleo || false,
    Sucre: employeeData.sucre || false,
    Vegan: employeeData.vegan || false,
    ProfilePicture: employeeData.profilePicture || "",
    Telephone: employeeData.telephone || "",
    Addresse: employeeData.addresse || "",
    Langue: employeeData.langue || "",
    DateNaissance: employeeData.dateNaissance || null,
    Urgence: employeeData.urgence || "",
    NvDptId: 0,
  });
  const handleChange = (key: string) => (event: any) => {
    let value;

    if (event.target.type === "checkbox") {
      value = event.target.checked;
    } else if (
      event.target.type === "date" ||
      event.target.type === "DateNaissance"
    ) {
      value = event.target.value || null;
    } else {
      value = event.target.value;
    }

    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onloadend = () => {
        const base64String = reader.result;
        setFormData({
          ...formData,
          ProfilePicture: base64String,
        });
      };
    }
  };

  const updateEmployee = async () => {
    try {
      let serviceId;
      try {
        const response = await axios.get(`${apiUrl}/NvDpt/${formData.Service}`);
        serviceId = parseInt(response.data.id, 10);
      } catch (error) {
        console.error("Error fetching serviceId:", error);

        serviceId = 0;
      }
      const updatedFormData = {
        ...formData,
        NvDptId: serviceId,
      };
      const response = await fetch(`${apiUrl}/Employee/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFormData),
      });

      if (response.ok) {
        onCancel();
        window.location.reload();
      } else {
      }
    } catch (error) {
      console.error("Error updating employee:", error);
    }
  };

  const handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    updateEmployee();
  };

  return (
    <div
      style={{
        backgroundColor: "#F0F4F8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper sx={{ padding: "20px" }} className="newdpt">
        <form>
          <Typography
            fontWeight="bold"
            paddingBottom="10px"
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#003671",
            }}
          >
            Modification fiche employé
          </Typography>
          <Grid
            container
            marginTop={4}
            marginBottom={4}
            paddingBottom={4}
            display="flex"
          >
            <Grid
              item
              xs={12}
              lg={2}
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              position="relative"
            >
              <Box
                width="165px"
                padding="15px"
                height="200px"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <img
                  src={formData.ProfilePicture}
                  alt={formData.Nom}
                  width={140}
                  height={140}
                  style={{
                    borderRadius: "50%",
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </Box>
              <label
                htmlFor="profile-picture-input"
                style={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translate(-50%, 32.5%)",
                  zIndex: 1,
                }}
              >
                <Button
                  variant="contained"
                  component="span"
                  sx={{
                    opacity: 0.8,
                    width: 140,
                    height: 140,
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.6)",
                  }}
                >
                  <svg
                    width="47"
                    height="45"
                    viewBox="0 0 47 45"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.4697 20.9069C37.6297 20.9069 40.6697 22.1639 42.9097 24.4019C45.1397 26.6389 46.3997 29.6739 46.3997 32.8389C46.3997 36.0029 45.1397 39.0379 42.9097 41.2759C40.6697 43.5129 37.6297 44.77 34.4697 44.77C31.2997 44.77 28.2698 43.5129 26.0298 41.2759C23.7898 39.0379 22.5398 36.0029 22.5398 32.8389C22.5398 29.6739 23.7898 26.6389 26.0298 24.4019C28.2698 22.1639 31.2997 20.9069 34.4697 20.9069ZM34.4697 25.2459L34.2698 25.2629C34.0598 25.3029 33.8597 25.4079 33.6997 25.5629C33.5497 25.7189 33.4397 25.9189 33.3997 26.1349L33.3796 26.3309V31.754H27.9597L27.7598 31.7739C27.5398 31.8129 27.3497 31.9179 27.1897 32.0739C27.0297 32.2289 26.9296 32.4289 26.8896 32.6459L26.8699 32.8409L26.8896 33.0359C26.9296 33.2529 27.0297 33.4519 27.1897 33.6079C27.3497 33.7639 27.5398 33.869 27.7598 33.908L27.9597 33.926H33.3796V39.356L33.3997 39.551C33.4397 39.767 33.5497 39.9669 33.6997 40.1229C33.8597 40.2789 34.0598 40.3829 34.2698 40.4229L34.4697 40.4399L34.6597 40.4229C34.8797 40.3829 35.0797 40.2789 35.2397 40.1229C35.3897 39.9669 35.4998 39.767 35.5398 39.551L35.5498 39.356V33.9229H40.9897L41.1797 33.908C41.3997 33.869 41.5998 33.7639 41.7498 33.6079C41.9098 33.4519 42.0098 33.2529 42.0498 33.0359L42.0698 32.8409L42.0498 32.6459C42.0098 32.4289 41.9098 32.2289 41.7498 32.0729C41.5998 31.9169 41.3997 31.8129 41.1797 31.7739L40.9797 31.7559H35.5498V26.3329L35.5398 26.1379C35.4998 25.9199 35.3897 25.72 35.2397 25.564C35.0797 25.408 34.8797 25.3029 34.6597 25.2629L34.4697 25.2459ZM26.7097 0.306946C27.5597 0.306946 28.3996 0.528928 29.1396 0.950928C29.8796 1.37393 30.4897 1.98197 30.9197 2.71497L32.6897 5.72394H37.1797C39.0497 5.72394 40.8397 6.46596 42.1697 7.78796C43.4897 9.10996 44.2297 10.9029 44.2297 12.7719V22.6639C43.2597 21.7349 42.1697 20.9489 40.9797 20.3279V12.7719C40.9797 11.7649 40.5799 10.8 39.8699 10.088C39.1499 9.37595 38.1897 8.97595 37.1797 8.97595H31.7598C31.4698 8.97595 31.1897 8.90193 30.9497 8.76093C30.6997 8.61993 30.4999 8.41791 30.3499 8.17291L28.1099 4.36096C27.9699 4.11696 27.7698 3.91493 27.5198 3.77393C27.2798 3.63293 26.9997 3.55896 26.7097 3.55896H18.4597C18.2297 3.55896 17.9898 3.61091 17.7798 3.71191C17.5598 3.81191 17.3697 3.95795 17.2197 4.13995L17.0798 4.33496L14.7097 8.19891C14.5597 8.43591 14.3599 8.63194 14.1099 8.76794C13.8699 8.90394 13.5998 8.97595 13.3198 8.97595H7.89966C7.39966 8.97495 6.8997 9.07292 6.4397 9.26392C5.9797 9.45492 5.55972 9.73391 5.20972 10.0869C4.85972 10.4389 4.57965 10.8579 4.38965 11.3189C4.19965 11.7789 4.09985 12.2729 4.09985 12.7719V33.3809C4.09985 35.4769 5.79965 37.1769 7.88965 37.1769H21.0498C21.4198 38.3339 21.9398 39.4269 22.5898 40.4319H7.88965C6.01965 40.4319 4.22967 39.689 2.90967 38.366C1.58967 37.044 0.839844 35.2509 0.839844 33.3809V12.7719C0.839844 10.9019 1.58967 9.10893 2.90967 7.78693C4.22967 6.46393 6.01965 5.72192 7.88965 5.72192H12.4097L14.2998 2.63196C14.7398 1.92096 15.3498 1.33394 16.0798 0.926941C16.8098 0.518941 17.6297 0.304932 18.4597 0.304932L26.7097 0.306946ZM22.5398 12.2299C24.5998 12.2299 26.6098 12.8829 28.2798 14.0969C29.9498 15.3109 31.1898 17.0219 31.8298 18.9849C30.7398 19.1909 29.6997 19.5209 28.7197 19.9589C28.2397 18.4859 27.2497 17.2329 25.9297 16.4249C24.5997 15.6179 23.0398 15.309 21.5098 15.554C19.9798 15.799 18.5798 16.582 17.5798 17.762C16.5798 18.942 16.0298 20.4419 16.0298 21.9919C16.0298 25.0939 18.1999 27.6859 21.0999 28.3419C20.7499 29.3729 20.5297 30.4409 20.4297 31.5239C18.0897 30.9989 16.0199 29.6289 14.6199 27.6749C13.2199 25.7219 12.5999 23.3219 12.8599 20.9349C13.1199 18.5479 14.2498 16.3409 16.0398 14.7349C17.8198 13.1299 20.1398 12.2389 22.5398 12.2319V12.2299Z"
                      fill="white"
                    />
                  </svg>
                </Button>
              </label>
              <Input
                type="file"
                onChange={handleFileChange}
                id="profile-picture-input"
                inputProps={{ accept: "image/*" }}
                sx={{ display: "none" }}
              />
            </Grid>

            <Grid item container xs={12} lg={10}>
              <Grid item container display="flex" xs={12}>
                <Grid
                  container
                  item
                  display="flex"
                  justifyContent="start"
                  spacing={5}
                  alignItems="center"
                  marginX={2}
                >
                  <Grid item lg={2}>
                    <InputLabel
                      htmlFor="nom-et-prénom"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Nom
                    </InputLabel>
                    <TextField
                      id="nom"
                      variant="outlined"
                      fullWidth
                      value={formData.Nom}
                      onChange={handleChange("Nom")}
                    />
                  </Grid>
                  <Grid item lg={3}>
                    <InputLabel
                      htmlFor="prénom"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Prénom
                    </InputLabel>
                    <TextField
                      id="nom-et-prénom"
                      variant="outlined"
                      fullWidth
                      value={formData.Prenom}
                      onChange={handleChange("Prenom")}
                    />
                  </Grid>
                  <Grid item lg={3}>
                    <InputLabel
                      htmlFor="poste"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Poste
                    </InputLabel>
                    <TextField
                      id="poste"
                      variant="outlined"
                      fullWidth
                      value={formData.Poste}
                      onChange={handleChange("Poste")}
                    />
                  </Grid>
                  <Grid item lg={2}>
                    <InputLabel
                      htmlFor="résponsabilité"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Résponsabilité
                    </InputLabel>
                    <Select
                      value={formData.Responsabilite}
                      variant="outlined"
                      fullWidth
                      onChange={handleChange("Responsabilite")}
                    >
                      <MenuItem value="Cadre">Cadre</MenuItem>
                      <MenuItem value="Chef de service">Chef</MenuItem>
                      <MenuItem value="collaborateur 2">
                        Collaborateur 2
                      </MenuItem>
                      <MenuItem value="collaborateur 1">
                        Collaborateur 1
                      </MenuItem>
                    </Select>
                  </Grid>
                  <Grid item lg={2}>
                    <InputLabel
                      htmlFor="service"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Service
                    </InputLabel>
                    <TextField
                      id="service"
                      variant="outlined"
                      fullWidth
                      value={formData.Service}
                      onChange={handleChange("Service")}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container display="flex" xs={12}>
                <Grid
                  container
                  item
                  display="flex"
                  justifyContent="start"
                  spacing={5}
                  alignItems="center"
                  marginX={2}
                >
                  <Grid item lg={3}>
                    <InputLabel
                      htmlFor="email"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Email
                    </InputLabel>
                    <TextField
                      id="email"
                      variant="outlined"
                      fullWidth
                      type="email"
                      value={formData.Email}
                      onChange={handleChange("Email")}
                    />
                  </Grid>
                  <Grid item lg={3}>
                    <InputLabel
                      htmlFor="Telephone"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Telephone
                    </InputLabel>
                    <TextField
                      id="Telephone"
                      variant="outlined"
                      fullWidth
                      type="tel"
                      value={formData.Telephone}
                      onChange={handleChange("Telephone")}
                    />
                  </Grid>
                  <Grid item lg={4}>
                    <InputLabel
                      htmlFor="Addresse"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Addresse
                    </InputLabel>
                    <TextField
                      id="Addresse"
                      variant="outlined"
                      fullWidth
                      value={formData.Addresse}
                      onChange={handleChange("Addresse")}
                    />
                  </Grid>
                  <Grid item lg={2}>
                    <InputLabel
                      htmlFor="langue"
                      sx={{
                        fontWeight: "bold",
                        color: "#101010",
                        marginBottom: "15px",
                      }}
                    >
                      Langue
                    </InputLabel>
                    <TextField
                      id="langue"
                      variant="outlined"
                      fullWidth
                      value={formData.Langue}
                      onChange={handleChange("Langue")}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={2} mx={2} mb={5}>
              <InputLabel
                htmlFor="date-de-naissance"
                sx={{
                  fontWeight: "bold",
                  color: "#101010",
                  marginBottom: "15px",
                }}
              >
                Date de naissance
              </InputLabel>
              <TextField
                id="date-de-naissance"
                variant="outlined"
                fullWidth
                type="date"
                value={
                  formData.DateNaissance
                    ? formData.DateNaissance.split("T")[0]
                    : ""
                }
                onChange={handleChange("DateNaissance")}
              />
            </Grid>
            <Grid item lg={2} mx={2}>
              <InputLabel
                htmlFor="contrat"
                sx={{
                  fontWeight: "bold",
                  color: "#101010",
                  marginBottom: "15px",
                }}
              >
                Contrat
              </InputLabel>
              <Select
                value={formData.ContractType}
                variant="outlined"
                fullWidth
                onChange={handleChange("ContractType")}
              >
                <MenuItem value="CDI">CDI</MenuItem>
                <MenuItem value="CDD">CDD</MenuItem>
              </Select>
            </Grid>
            <Grid item lg={2} mx={2}>
              <InputLabel
                htmlFor="Date d'embauche"
                sx={{
                  fontWeight: "bold",
                  color: "#101010",
                  marginBottom: "15px",
                }}
              >
                Date d'embauche
              </InputLabel>
              <TextField
                id="date-d'embauche'"
                variant="outlined"
                fullWidth
                type="date"
                value={
                  formData.ContractStartDate
                    ? formData.ContractStartDate.split("T")[0]
                    : ""
                }
                onChange={handleChange("ContractStartDate")}
              />
            </Grid>
            <Grid item lg={2} mx={2}>
              <InputLabel
                htmlFor="date-de-fin"
                sx={{
                  fontWeight: "bold",
                  color: "#101010",
                  marginBottom: "15px",
                }}
              >
                Date de fin 
              </InputLabel>
              <TextField
                id="date-de-fin"
                variant="outlined"
                fullWidth
                type="date"
                value={
                  formData.ContractEndDate
                    ? formData.ContractEndDate.split("T")[0]
                    : ""
                }
                onChange={handleChange("ContractEndDate")}
              />
            </Grid>
            <Grid item lg={2} mx={2}>
              <InputLabel
                htmlFor="contact d'urgence"
                sx={{
                  fontWeight: "bold",
                  color: "#101010",
                  marginBottom: "15px",
                }}
              >
                Contact d'urgence
              </InputLabel>
              <TextField
                id="contact d'urgence"
                variant="outlined"
                fullWidth
                type="tel"
                value={formData.Urgence}
                onChange={handleChange("Urgence")}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid container item spacing={10} alignItems="start">
              <Grid container item sm={6}>
                <Stack my={2} flexDirection="row" alignItems="center">
                  <Typography marginRight={2}>Allergies</Typography>
                  <img src={Sign} alt="Sign" width={15} height={15} />
                  <svg
                    width="100%"
                    height="1"
                    viewBox="0 0 350 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.5"
                      d="M0 0.5H350"
                      stroke="black"
                      stroke-opacity="0.2"
                    />
                  </svg>
                </Stack>

                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Gluten")}
                            checked={formData.Gluten}
                          />
                        }
                        label="Gluten"
                      />
                      <img src={Glutin} alt="Gluten" width={15} height={15} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Laitier")}
                            checked={formData.Laitier}
                          />
                        }
                        label="Produit laitier"
                      />
                      <img
                        src={Laitier}
                        alt="Produit laitier"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Crustaces")}
                            checked={formData.Crustaces}
                          />
                        }
                        label="Crustacés"
                      />
                      <img
                        src={Crustacés}
                        alt="Crustacés"
                        width={15}
                        height={15}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Oeuf")}
                            checked={formData.Oeuf}
                          />
                        }
                        label="Oeuf"
                      />
                      <img src={Oeuf} alt="Oeuf" width={15} height={15} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Poisson")}
                            checked={formData.Poisson}
                          />
                        }
                        label="Poisson"
                      />
                      <img src={Poisson} alt="Poisson" width={15} height={15} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Arachides")}
                            checked={formData.Arachides}
                          />
                        }
                        label="Arachides"
                      />
                      <img
                        src={Arachides}
                        alt="Arachides"
                        width={15}
                        height={15}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Soja")}
                            checked={formData.Soja}
                          />
                        }
                        label="Soja"
                      />
                      <img src={Soga} alt="Soja" width={15} height={15} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Coques")}
                            checked={formData.Coques}
                          />
                        }
                        label="Fruits à coques"
                      />
                      <img
                        src={Fruits}
                        alt="Fruits à coques"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Celeri")}
                            checked={formData.Celeri}
                          />
                        }
                        label="Céleri"
                      />
                      <img src={Céleri} alt="Céleri" width={15} height={15} />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Moutarde")}
                            checked={formData.Moutarde}
                          />
                        }
                        label="Grains Moutarde"
                      />
                      <img
                        src={Moutarde}
                        alt="Grains Moutarde"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Sesames")}
                            checked={formData.Sesames}
                          />
                        }
                        label="Grains Sésames"
                      />
                      <img
                        src={Sésames}
                        alt="Grains Sésames"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Sulfites")}
                            checked={formData.Sulfites}
                          />
                        }
                        label="Sulfites"
                      />
                      <img
                        src={Sulfites}
                        alt="Sulfites"
                        width={15}
                        height={15}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Mollusques")}
                            checked={formData.Mollusques}
                          />
                        }
                        label="Mollusques"
                      />
                      <img
                        src={Mollusques}
                        alt="Mollusques"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Ail")}
                            checked={formData.Ail}
                          />
                        }
                        label="Ail , Oignon"
                      />
                      <img
                        src={Ail}
                        alt="Ail , Oignon"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Lupin")}
                            checked={formData.Lupin}
                          />
                        }
                        label="Lupin"
                      />
                      <img src={Lupin} alt="Lupin" width={15} height={15} />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Champignons")}
                            checked={formData.Champignons}
                          />
                        }
                        label="Champignons"
                      />
                      <img
                        src={Champignons}
                        alt="Champignons"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Tomates")}
                            checked={formData.Tomates}
                          />
                        }
                        label="Tomates"
                      />
                      <img src={Tomates} alt="Tomates" width={15} height={15} />
                    </Grid>
                  </Grid>
                </FormGroup>
              </Grid>
              <Grid container item sm={6}>
                <Stack my={2} flexDirection="row" alignItems="center">
                  <Typography width="80%">Préferences alimentaires</Typography>
                  <img src={Sign} alt="Sign" width={15} height={15} />
                  <svg
                    width="100%"
                    height="1"
                    viewBox="0 0 350 1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.5"
                      d="M0 0.5H350"
                      stroke="black"
                      stroke-opacity="0.2"
                    />
                  </svg>
                </Stack>

                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Halal")}
                            checked={formData.Halal}
                          />
                        }
                        label="Halal"
                      />
                      <img src={Halal} alt="Halal" width={20} height={20} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Kosher")}
                            checked={formData.Kosher}
                          />
                        }
                        label="Kosher"
                      />
                      <img src={Kosher} alt="Kosher" width={20} height={20} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Paleo")}
                            checked={formData.Paleo}
                          />
                        }
                        label="Paleo"
                      />
                      <img src={Paleo} alt="Paleo" width={20} height={20} />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Pescatarien")}
                            checked={formData.Pescatarien}
                          />
                        }
                        label="Pescatarien"
                      />
                      <img
                        src={Pescatarien}
                        alt="Pescatarien"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Porc")}
                            checked={formData.Porc}
                          />
                        }
                        label="Sans porc"
                      />
                      <img
                        src={Sans_porc}
                        alt="Sans porc"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Sucre")}
                            checked={formData.Sucre}
                          />
                        }
                        label="Sans sucre"
                      />
                      <img
                        src={Sans_sucre}
                        alt="Sans sucre"
                        width={15}
                        height={15}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Enceinte")}
                            checked={formData.Enceinte}
                          />
                        }
                        label="Enceinte"
                      />
                      <img
                        src={Enceinte}
                        alt="Enceinte"
                        width={20}
                        height={20}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Seafood")}
                            checked={formData.Seafood}
                          />
                        }
                        label="Seafood"
                      />
                      <img src={Seafood} alt="Seafood" width={15} height={15} />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Vegan")}
                            checked={formData.Vegan}
                          />
                        }
                        label="Vegan"
                      />
                      <img src={Vegan} alt="Vegan" width={20} height={20} />
                    </Grid>
                  </Grid>
                </FormGroup>
                <FormGroup row sx={{ width: "100%" }}>
                  <Grid container item spacing={2}>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Vegetarien")}
                            checked={formData.Vegetarien}
                          />
                        }
                        label="Végétarien"
                      />
                      <img
                        src={Végétarien}
                        alt="Végétarien"
                        width={15}
                        height={15}
                      />
                    </Grid>
                    <Grid
                      item
                      sm={4}
                      direction="row"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={handleChange("Diabetique")}
                            checked={formData.Diabetique}
                          />
                        }
                        label="Diabétique"
                      />
                      <img
                        src={Diabétique}
                        alt="Diabétique"
                        width={15}
                        height={15}
                      />
                    </Grid>
                  </Grid>
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid container justifyContent="space-between">
            <Grid item paddingY={2}></Grid>
            <Grid item paddingY={2}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#003671", borderRadius: "10px" }}
                type="submit"
                onClick={handleSubmit}
              >
                <Typography
                  fontWeight="bold"
                  fontSize="12px"
                  paddingX={4}
                  paddingY={1}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Valider
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </div>
  );
}

export default App;
